<!-- Slider main container -->
<div class="swiper {{className}}" [class.white-controls]="whiteControls">
  <!-- Additional required wrapper -->
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let page of pagesToShow">
      <ng-container *ngTemplateOutlet="page"></ng-container>
    </div>
  </div>


  @if (withPagination) {
    <div class="swiper-pagination"></div>
  }


  @if (withNavigation) {
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  }


  <div class="back-to-last-slide" *ngIf="backButtonEnabled && showBackButton">
    <button [appButton]="'secondary'" (click)="goToLastSlide()">
      {{ "general.back" | translate }}
    </button>
  </div>
</div>
